/**
 * @license
 * Copyright (c) 2011 %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import pick from 'ramda/src/pick';

// TODO: fully implement Logger
export const Logger = pick(['error', 'warn', 'info', 'log'], console);
